import "vue-multiselect/dist/vue-multiselect.min.css"
import MassCoursesAssignment from "@/components/mass-courses-assignment.vue";
import OjMultiselect from "@/components/oj-multiselect.vue";
import SelectStudent from "@/components/select-student.vue";
import Gift_vouchers from "@/components/tables/gift_vouchers.vue";

import {add_vueApp2} from "@/packs/vue_helper.js";
import OrganizationGroupSupervisorsComponent from "@/components/organization/organization-group-supervisors-component.vue";

import KonverzkyProjectOptions from "./tables/konverzky-project-options.vue";
import OnlajnovkaLessons from "./onlajnovka/lessons.vue"
import AppOnlajnovkaStudents from "@/components/onlajnovka/app-onlajnovka-students.vue";
import StudentTesty from "@/components/student-testy.vue";

import ChangeExpirationGroup from "@/components/organization/change-expiration-group.vue";

import OjMultiselectProductMonths from "./partials/oj-multiselect-product-months.vue";
import PastLessons from "@/components/onlajnovka/past-lessons.vue";
import ProductGiftvoucherForm from "@/components/ProductGiftvoucherForm.vue";

import LLMyStudentsAppIndex from "./ll/my_students.vue"
import LLMyLessonsAppIndex from "./ll/my_lessons.vue"
import LLStudentDashboardAppIndex from "./ll/student-dashboard.vue"
import LLPricesAdmin from "./ll/admin-ll-prices.vue"

import OrderItems2 from "./order-items2.vue"

import { createI18n } from 'vue-i18n';
import cs from '../locales/cs.json';
import en from '../locales/en.json';
import pl from '../locales/pl.json';
import es from '../locales/es.json';
import sk from '../locales/sk.json';

const el = document.getElementsByTagName('html')[0]
const lang = el.getAttribute('lang') || 'cs';

const i18n = createI18n({
    locale: lang,
    fallbackLocale: 'cs',
    messages: {
        cs,
        en,
        pl,
        es,
        sk
    }
});

add_vueApp2('organization-group-supervisors-component', OrganizationGroupSupervisorsComponent)

add_vueApp2('component-oj-multiselect-courses', OjMultiselect)
add_vueApp2("component-oj-multiselect-products", OjMultiselectProductMonths)
add_vueApp2('component-courses-multiselect-category', OjMultiselect)
add_vueApp2('gift_vouchers_app', Gift_vouchers)
add_vueApp2('konverzky-project-options', KonverzkyProjectOptions)
add_vueApp2('app-onlajnovka-lessons', OnlajnovkaLessons)

add_vueApp2('app-onlajnovka-past-lessons', PastLessons)

add_vueApp2('ll-students-app-index', LLMyStudentsAppIndex)

//ll-lessons-app-index
add_vueApp2('ll-lessons-app-index', LLMyLessonsAppIndex)
add_vueApp2('ll-student-dashboard-app', LLStudentDashboardAppIndex, [i18n])
add_vueApp2('ll-prices' , LLPricesAdmin)

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.oj-multiselect-component');
    elements.forEach((element) => {
        add_vueApp2(element.id, OjMultiselect);
    });


    add_vueApp2('app-mass-assignment-courses-group', MassCoursesAssignment)

    add_vueApp2('app-student-testy', StudentTesty)
    // app-change-expiration-group
    add_vueApp2('app-change-expiration-group', ChangeExpirationGroup)


    add_vueApp2('component-darkovy-poukaz-productform', ProductGiftvoucherForm )


    add_vueApp2('app-order-items2', OrderItems2)

})


add_vueApp2('component-select-student', SelectStudent)
add_vueApp2('app-onlajnovka-students', AppOnlajnovkaStudents )